import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Injectable, Injector } from '@angular/core';
import { IDataModal } from '@pacifico/interfaces/components.interface';
import { ModalFunction } from '@pacifico/utils/modal-fuction';
import { ModalLateralComponent } from './modal-lateral.component';
import { ModalLateralModule } from './modal-lateral.module';
import { DialogRef } from './models/modal-ref';

@Injectable({
	providedIn: ModalLateralModule
})
export class ModalLateralService {
	dialogComponentRef!: ComponentRef<ModalLateralComponent>;
	private _modalFunction!: ModalFunction<ModalLateralComponent>;
	constructor(componentFactoryResolver: ComponentFactoryResolver, appRef: ApplicationRef, injector: Injector) {
		this._modalFunction = new ModalFunction(componentFactoryResolver, appRef, injector, ModalLateralComponent, true);
	}

	open(config: IDataModal): DialogRef {
		const dialogRef = this._modalFunction.appendDialogComponentToBody();
		this.dialogComponentRef = this._modalFunction.dialogComponentRef;
		this.dialogComponentRef.instance.datamodal = config;

		return dialogRef;
	}

	forceCloseOnError(): void {
		this._modalFunction.forceClose();
	}
}
